import { Container } from 'shared/Houston';

import styled from '@eduzz/houston-styles/styled';

export const PageWrapper = styled(Container)`
  && {
    padding: ${({ theme }) => `0 ${theme.spacing.inline.xxxs}`};
  }
`;
